import Button from './Button';

export default function Loading() {
    return(
        <div className="loading-page">
            <h3>Laadin...</h3><div id="loading"></div>
            <Button text={"Värskenda lehte"} href={"/"} type={'btn btn-primary'} />
        </div>
    )
}